// The truth-set eval ledger, newest first: when, how triggered, which variant,
// the verdict tallies, cost and latency. Click a run to open its cases.

import type { EvalRunRead } from '../../services/fastpathQuality';
import { ms, passRate, triggerLabel, usd, variantSummary, whenUtc } from './format';
import styles from '../FastpathQualityPage.module.css';

interface Props {
  runs: EvalRunRead[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function EvalRunsTable({ runs, selectedId, onSelect }: Props) {
  return (
    <section className={styles.panel} aria-label="Truth-set runs">
      <div className={styles.panelHead}>
        <h2>Runs</h2>
        <span className={styles.meta}>newest first · click a run to see its cases</span>
      </div>
      {runs.length === 0 ? (
        <p className={styles.empty}>No eval run yet. The weekly beat runs one; or run it now.</p>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>started</th>
                <th>trigger</th>
                <th>status</th>
                <th>variant</th>
                <th>truth set</th>
                <th className={styles.num}>pass</th>
                <th className={styles.num}>passed / partial / failed / handoff / error</th>
                <th className={styles.num}>cost</th>
                <th className={styles.num}>p50 / p95</th>
              </tr>
            </thead>
            <tbody>
              {runs.map((run) => (
                <tr
                  key={run.id}
                  className={`${styles.clickable} ${run.id === selectedId ? styles.selectedRow : ''}`}
                  onClick={() => onSelect(run.id)}
                  data-status={run.status}
                >
                  <td>{whenUtc(run.started_at)}</td>
                  <td>{triggerLabel(run.trigger)}</td>
                  <td><span className={`${styles.state} ${styles[`state_${run.status}`]}`}>{run.status}</span></td>
                  <td className={styles.note} title={JSON.stringify(run.variant)}>{variantSummary(run.variant)}</td>
                  <td>{run.truth_set_version}{run.git_sha ? ` @ ${run.git_sha.slice(0, 7)}` : ''}</td>
                  <td className={styles.num}>{passRate(run)}</td>
                  <td className={styles.num}>
                    {run.cases_passed} / {run.cases_partial} / {run.cases_failed} / {run.cases_handoff} / {run.cases_error}
                  </td>
                  <td className={styles.num}>{usd(run.cost_usd)}</td>
                  <td className={styles.num}>{ms(run.latency_p50_ms)} / {ms(run.latency_p95_ms)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
